import { RolePermissions } from '../constants/permissions';
const RolePermissionSets = Object.fromEntries(Object.entries(RolePermissions).map(([role, perms]) => [role, new Set(perms)]));

// Defensive fallback for runtime callers passing an unvalidated role string
// (e.g. from JWT claims before role validation middleware runs).
export function hasPermission(role, permission) {
  var _RolePermissionSets$r, _RolePermissionSets$r2;
  return (_RolePermissionSets$r = (_RolePermissionSets$r2 = RolePermissionSets[role]) == null ? void 0 : _RolePermissionSets$r2.has(permission)) != null ? _RolePermissionSets$r : false;
}
//# sourceMappingURL=permissions.js.map